import { useQuery } from "@tanstack/react-query";
import ConfigHolder from "../../config/ConfigHolder";
import useWidgetStore from "../../store/useWidgetStore";
import { useSettings } from "../../context/SettingsContext";
export const useValidateVoucher = (formContext, options) => {
    const { api_key, widget_id } = useSettings();
    const { 
    // language,
    consumer, cart } = useWidgetStore();
    const defaultOptions = Object.assign(Object.assign({}, options), { enabled: false, networkMode: "always", cacheTime: 0, staleTime: 0 });
    return useQuery(Object.assign(Object.assign({}, defaultOptions), { queryKey: ['widget-voucher-validate'], queryFn: async ({ signal }) => {
            var _a, _b;
            let url = ConfigHolder.getApiMethodUrl(api_key, widget_id, 'validateVoucher', 'checkout');
            const data = {
                order_id: (_a = cart.order_id) !== null && _a !== void 0 ? _a : '',
                code: formContext.getValues('code').replaceAll(' ', '').toUpperCase(),
                customerId: (_b = consumer.id) !== null && _b !== void 0 ? _b : '',
            };
            const response = await fetch(url.href, {
                signal: signal,
                method: "POST",
                headers: {
                    'Content-Type': 'application/json', // checks this header if it's a POST, while calling the method getRestData.... That's not Restful
                    'X-OAnl-csrf-protection': 'on',
                    'accept': 'application/json+ld',
                },
                body: JSON.stringify(data)
            });
            return response.json();
        } }));
};
